/* Shop policy pages: structure legacy plain-text policies and add navigation. Does not change any wording. */
(() => {
  const container = document.querySelector('.shopify-policy__container');
  const rte = container && container.querySelector('.shopify-policy__body .rte');
  const titleWrap = container && container.querySelector('.shopify-policy__title');
  if (!rte || !titleWrap) return;

  let data = {};
  try { data = JSON.parse(document.getElementById('pp-data').textContent); } catch (e) {}
  const el = (tag, cls, html) => { const n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; };
  const txt = (n) => (n.textContent || '').replace(/ /g, ' ').trim();
  const slug = (s) => s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
  const SMALL = new Set(['and', 'or', 'of', 'the', 'a', 'an', 'to', 'in', 'on', 'for', 'by', 'with']);
  const nice = (s) => {
    s = s.replace(/\s+/g, ' ').replace(/\s-\s/g, ' — ').trim();
    const letters = s.replace(/[^A-Za-z]/g, '');
    const upper = letters.replace(/[^A-Z]/g, '').length;
    if (!letters.length || upper / letters.length < 0.6) return s;
    return s.toLowerCase().split(' ').map((w, i) => (i > 0 && SMALL.has(w)) ? w : w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  };

  /* ---- 1. legacy structure: <strong> headings and <br><br> paragraphs inside big <p> blocks ---- */
  const legacy = rte.querySelectorAll('h2').length < 3;
  const isBlank = (n) => n.nodeType === 3 ? !n.textContent.replace(/ /g, ' ').trim() : false;
  const isBr = (n) => n && n.nodeType === 1 && n.tagName === 'BR';
  const nextMeaningful = (nodes, i) => { let j = i + 1; while (j < nodes.length && isBlank(nodes[j])) j++; return j; };

  if (legacy) {
    [...rte.querySelectorAll(':scope > p')].forEach((p) => {
      const nodes = [...p.childNodes];
      const out = [];
      let cur = [];
      const flush = () => {
        while (cur.length && (isBlank(cur[0]) || isBr(cur[0]))) cur.shift();
        while (cur.length && (isBlank(cur[cur.length - 1]) || isBr(cur[cur.length - 1]))) cur.pop();
        if (cur.some((n) => !isBlank(n))) { const np = el('p'); cur.forEach((n) => np.appendChild(n.cloneNode(true))); out.push(np); }
        cur = [];
      };
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        const startOfBlock = cur.every((c) => isBlank(c) || isBr(c));
        if (n.nodeType === 1 && (n.tagName === 'STRONG' || n.tagName === 'B') && startOfBlock && txt(n).length <= 140 && txt(n).length > 1) {
          const j = nextMeaningful(nodes, i);
          if (j >= nodes.length || isBr(nodes[j])) {
            flush(); out.push(el('h2', null, nice(txt(n)).replace(/</g, '&lt;')));
            i = (j < nodes.length && isBr(nodes[j])) ? j : nodes.length; continue;
          }
        }
        if (isBr(n)) {
          const j = nextMeaningful(nodes, i);
          if (j < nodes.length && isBr(nodes[j])) { flush(); i = j; while (i + 1 < nodes.length && (isBr(nodes[i + 1]) || isBlank(nodes[i + 1]))) i++; continue; }
        }
        cur.push(n);
      }
      flush();
      p.replaceWith(...out);
    });
    rte.querySelectorAll(':scope > p').forEach((p) => { if (!txt(p) && !p.querySelector('img')) p.remove(); });
  }

  /* ---- 2. header: kicker, "last updated" pill, switcher ---- */
  const h1 = titleWrap.querySelector('h1');
  titleWrap.insertBefore(el('p', 'pp-kicker', data.i18n?.kicker || ''), h1);
  const first = rte.firstElementChild;
  if (first && first.tagName === 'P' && /^last updated/i.test(txt(first))) { titleWrap.appendChild(el('span', 'pp-meta', txt(first).replace(/</g, '&lt;'))); first.remove(); }
  if (data.policies && data.policies.length) {
    const ul = el('ul', 'pp-switch');
    data.policies.forEach((p) => {
      const li = el('li'); const a = el('a', null, p.title.replace(/</g, '&lt;')); a.href = p.url;
      if (location.pathname.replace(/\/$/, '') === p.url.replace(/\/$/, '')) a.setAttribute('aria-current', 'page');
      li.appendChild(a); ul.appendChild(li);
    });
    titleWrap.appendChild(ul);
  }

  /* ---- 3. lead paragraph (legacy pages only) ---- */
  const fp = rte.firstElementChild;
  if (legacy && fp && fp.tagName === 'P') { const L = txt(fp).length; if (L > 40 && L < 260) fp.classList.add('pp-lead'); }

  /* ---- 4. "Label: value" pages (contact information) -> cards ---- */
  const kids = [...rte.children];
  const pairs = kids.map((k) => k.tagName === 'P' ? txt(k).match(/^([^:]{2,40}):\s+(.+)$/) : null);
  if (kids.length >= 2 && kids.length <= 8 && pairs.every(Boolean) && !rte.querySelector('h2')) {
    const dl = el('dl', 'pp-cards');
    pairs.forEach((m, i) => {
      const label = m[1], value = m[2];
      const card = el('div', 'pp-card' + (/address/i.test(label) ? ' pp-card--wide' : ''));
      const dt = el('dt', null, label.replace(/</g, '&lt;'));
      const dd = el('dd');
      if (/@/.test(value)) { const a = el('a', null, value.replace(/</g, '&lt;')); a.href = 'mailto:' + value; dd.appendChild(a); }
      else if (/^[\d\s().+-]{7,}$/.test(value)) { const a = el('a', null, value); a.href = 'tel:' + value.replace(/[^\d+]/g, ''); dd.appendChild(a); }
      else dd.textContent = value;
      card.append(dt, dd); dl.appendChild(card);
    });
    rte.replaceChildren(dl);
  }

  /* ---- 5. tables ---- */
  rte.querySelectorAll('table').forEach((t) => { const w = el('div', 'pp-table'); t.replaceWith(w); w.appendChild(t); });

  /* ---- 6. help card ---- */
  if (!rte.querySelector('.pp-cards') && data.email) {
    const help = el('div', 'pp-help');
    help.innerHTML = '<div><p class="pp-help__title">' + (data.i18n?.helpTitle || '') + '</p><p class="pp-help__text">' + (data.i18n?.helpText || '') + '</p></div>';
    const a = el('a', 'pp-help__btn', data.i18n?.emailUs || ''); a.href = 'mailto:' + data.email; help.appendChild(a);
    rte.appendChild(help);
  }

  /* ---- 6b. shipping policy: per-product explorer above the text ---- */
  const tpl = document.getElementById('pp-shipping');
  if (tpl) {
    const node = tpl.content.firstElementChild.cloneNode(true);
    const tabs = [...node.querySelectorAll('[data-pps-tab]')];
    const panels = [...node.querySelectorAll('[data-pps-panel]')];
    const pick = (key) => {
      tabs.forEach((t) => { const on = t.dataset.ppsTab === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      panels.forEach((p) => { p.hidden = p.dataset.ppsPanel !== key; });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => pick(t.dataset.ppsTab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; pick(n.dataset.ppsTab); n.focus();
      });
    });
    const fromHash = tabs.find((t) => location.hash === '#' + t.dataset.ppsTab);
    if (fromHash) pick(fromHash.dataset.ppsTab);
    container.querySelector('.shopify-policy__body').prepend(node);
  }

  /* ---- 7. table of contents + layout ---- */
  const heads = [...rte.querySelectorAll('h2')];
  const grid = el('div', 'pp-grid');
  rte.replaceWith(grid);
  if (heads.length >= 3) {
    const used = new Set();
    const toc = el('details', 'pp-toc');
    toc.appendChild(el('summary', null, (data.i18n?.onThisPage || '')));
    toc.appendChild(el('p', 'pp-toc__label', (data.i18n?.onThisPage || '')));
    const ol = el('ol');
    const links = heads.map((h) => {
      let id = slug(txt(h)), n = 2; while (used.has(id)) id = slug(txt(h)) + '-' + n++; used.add(id); h.id = id;
      const li = el('li'); const a = el('a', null, txt(h).replace(/</g, '&lt;')); a.href = '#' + id; li.appendChild(a); ol.appendChild(li); return a;
    });
    toc.appendChild(ol);
    const mq = window.matchMedia('(min-width: 990px)');
    const sync = () => { toc.open = mq.matches; };
    sync(); (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));
    grid.append(toc, rte);
    ol.addEventListener('click', (e) => { if (!mq.matches && e.target.closest('a')) toc.open = false; });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id)); } });
      }, { rootMargin: '-15% 0px -70% 0px' });
      heads.forEach((h) => io.observe(h));
      links[0].classList.add('is-active');
    }
  } else {
    grid.classList.add('pp-grid--single'); grid.appendChild(rte);
  }
})();
